<template>
  <div class="module-wrapper linebottomg" v-if="content !== '--'">
    <div class="holdTitleVma">投资理念 </div>
    <div class="touziln">
        <div class="touzilnwz">{{content}}</div>
    </div>
    <img class="manager-img" :src="imgurl" alt />
  </div>
</template>

<script>
import StoreManger from '@/utils/FundHQJHManger';
// import dataModel from '@/model/fundmanager.model';
import {
  detailPushPage,
} from '@/utils/nativeBridge';
import defoultImg from '@/assets/avator.png';

export default {
  name: 'FundManager',
  components: {
  },
  data() {
    return {
      content: '--',
      imgurl: '--',
    };
  },
  computed: {},
  created() {
    this.render();
  },
  mounted() {
  },
  methods: {
    render() {
      const baseInfo = StoreManger.getFundJJXQ();
      if (baseInfo) {
        this.content = baseInfo.INVESTMENTIDEAR ? baseInfo.INVESTMENTIDEAR : '--';
        this.imgurl = baseInfo.INVESTMENTIDEARIMG;
      }
    },
    configHDDataToShowData(datas) {
      if (datas && Object.prototype.toString.call(datas) === '[object Array]' && datas.length > 0) {
        const item = datas[0];
        const {
          DAYS,
          FEMPDATE,
          LEMPDATE,
          PENAVGROWTH,
          MANGER,
        } = item;
        const mList = [];
        if (MANGER) {
          MANGER.forEach((element) => {
            // 日期
            const daysInt = parseInt(DAYS, 10);
            let str = '(';
            if (daysInt < 365) {
              str += (`${daysInt}天`);
            } else if (daysInt === 365) {
              str += ('1年');
            } else {
              str += (`${parseInt(daysInt / 365.0, 10)}年又${daysInt % 365}天`);
            }
            str += ')';
            const days = str;
            // 名称
            const names = element.MGRNAME ? element.MGRNAME : '--';
            // 图片
            const icons = element.NEWPHOTOURL ? element.NEWPHOTOURL : '--';
            // mid
            const mid = element.MGRID ? element.MGRID : '--';
            // isINOFFICE
            const isINOFFICE = element.ISINOFFICE ? element.ISINOFFICE : '--';
            // INVESTMENTIDEAR
            const tzln = element.INVESTMENTIDEAR ? element.INVESTMENTIDEAR : '--';
            // 时间
            let timeStr = `${FEMPDATE}`;
            if (!LEMPDATE || LEMPDATE.length === 0 || LEMPDATE === '--') {
              timeStr += '~至今';
            } else {
              timeStr += `~${LEMPDATE}`;
            }
            const time = timeStr;
            // rate
            let rate = '--';
            if (PENAVGROWTH) {
              if (PENAVGROWTH === '--') {
                rate = '--';
              } else {
                rate = `${parseFloat(PENAVGROWTH).toFixed(2)}`;
              }
            }
            mList.push({
              rate,
              time,
              isINOFFICE,
              mid,
              icons,
              names,
              days,
              tzln,
            });
          });
        }
        return mList;
      }
      return [];
    },
    fetchRequest() {
      return new Promise((resolve) => {
        const resData = this.configHDDataToShowData(StoreManger.getFundJJJL());
        resolve(resData);
      });
    },
    checkData(data) {
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 0);
    },
    handleDefault() {
      // this.pageData = dataModel.objectArrayWithKeyValuesArray([{}], [{}]);
    },
    confPer(value) {
      // eslint-disable-next-line use-isnan
      if (value === '--') {
        return '--';
      }
      if (Number.isNaN(value)) {
        return '--';
      }
      const newV = parseFloat(value);
      return `${newV.toFixed(2)}%`;
    },
    upDown(value) {
      const newV = parseFloat(value);
      if (newV > 0) {
        return 'red';
      }
      if (newV < 0) {
        return 'green';
      }
      return 'gray';
    },
    getManagerImage(item) {
      if (item) {
        if (item.icons) {
          return item.icons;
        }
      }
      return defoultImg;
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const code = StoreManger.getFundJJXQCODE(baseInfo);
      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/FundManagerList',
        params: {
          FCODE: code,
        },
      });
      this.reportMonitor({
        eventName: 'pz.xx.jjjl',
      });
    },
  },
};
</script>

<style scoped lang="less">
.holdTitleVma{
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  letter-spacing: 0;
  line-height: 28px;
  margin-bottom: 20px;
  margin-top: 6px;
}
.module-wrapper {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
}
.manager {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.manager-img {
  width: 100%;
  object-fit: cover;
}
.touziln{
  background: #ffffff;
  border-radius: 8px;
}
.touzilnwz{
 padding: 24px 0;
 padding-bottom: 0;
 padding-top: 0px;
 font-size: 30px;
 color: #000000;
 text-align: justify;
 line-height: 50px;
 word-wrap:break-word;
}
</style>
